import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import { quickStats, trending } from "@/mocks/trending";

const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=Moody%20editorial%20abstract%20background%20with%20warm%20vermillion%20and%20deep%20teal%20color%20fields%2C%20dramatic%20light%20streaks%2C%20film%20grain%20texture%2C%20cinematic%20atmosphere%2C%20no%20people%2C%20high%20contrast%20gradient%20for%20white%20text%20overlay%2C%20artistic%20minimalist%20composition%2C%20rich%20warm%20tones%20and%20dark%20shadows&width=1600&height=900&seq=rr-hero-mayday&orientation=landscape";

export default function HeroSection() {
  const ticker = [...trending, ...trending];
  return (
    <>
      <section className="relative flex min-h-[620px] w-full items-center overflow-hidden pt-20 md:min-h-[720px] md:pt-24">
        <img
          src={HERO_IMAGE}
          alt="五一假期事件盘点专题主视觉"
          title="黑料五一 · 假期事件盘点"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/55 to-foreground-950/92" />

        <Container className="relative z-10 w-full py-16 md:py-20">
          <div className="max-w-3xl rr-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium tracking-wide text-background-100 backdrop-blur">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
              五一假期 · 舆情观察 · 2026
            </span>

            <h1 className="mt-5 font-heading text-[32px] font-black leading-[1.15] text-background-50 md:text-[56px] md:leading-[1.1]">
              黑料五一 · 假期事件盘点
            </h1>

            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
              集中整理劳动节前后被广泛讨论的事件、争议与行业动态。按时间顺序梳理黑料五一期间大事件，覆盖娱乐动态、品牌营销、出行消费与社交热点，帮你一次看全假期里错过的热门爆料。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link
                to="/topics"
                className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-book-open-line text-base" />
                浏览全部盘点
              </Link>
              <a
                href="#timeline"
                className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-time-line text-base" />
                查看事件时间线
              </a>
            </div>

            <dl className="mt-10 grid max-w-2xl grid-cols-2 gap-x-6 gap-y-5 sm:grid-cols-4">
              {quickStats.map((stat) => (
                <div key={stat.label}>
                  <dd className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                    {stat.value}
                    <span className="ml-1 text-xs font-normal text-background-200/80">{stat.unit}</span>
                  </dd>
                  <dt className="mt-1 text-xs text-background-200/75">{stat.label}</dt>
                </div>
              ))}
            </dl>
          </div>
        </Container>
      </section>

      <div className="w-full overflow-hidden bg-primary-950 py-3">
        <div className="flex w-max items-center gap-8 rr-marquee">
          {ticker.map((item, index) => (
            <span
              key={`${item.title}-${index}`}
              className="flex items-center gap-2 whitespace-nowrap text-sm text-background-100/90"
            >
              <span className="flex h-5 items-center rounded-sm bg-accent-500 px-1.5 text-[10px] font-bold text-primary-950">
                {item.tag}
              </span>
              {item.title}
              <i className="ri-fire-line text-primary-300" />
            </span>
          ))}
        </div>
      </div>
    </>
  );
}